export const BlogUrl = "https://blog.optimistic-news.com";
export const articlesUrl = "/articles";
export const discussionsUrl = "/discussions";
export const todayUrl = "/today";
